export default __webpack_public_path__ + "static/media/WoL_web_checker_banner_image_logo2-min.4767af01.jpg";